import { motion, AnimatePresence } from "framer-motion";
import { Center, Text, Input, Tooltip, Container, Button } from "@mantine/core";
import { IconKey, IconUser, IconAlertCircle } from "@tabler/icons-react";
import Places from "./Places";
import { Map } from "centeridentityreact";
import { useEffect } from "react";
import { notifications } from "@mantine/notifications";

const mapStyles = [
  {
    featureType: "all",
    elementType: "labels",
    stylers: [{ visibility: "off" }],
  },
  {
    featureType: "administrative.country",
    elementType: "labels",
    stylers: [{ visibility: "on" }],
  },
  {
    featureType: "administrative.province",
    elementType: "labels",
    stylers: [{ visibility: "on" }],
  },
  {
    featureType: "administrative.locality",
    elementType: "labels",
    stylers: [{ visibility: "on" }],
  },
  {
    featureType: "road",
    elementType: "labels",
    stylers: [{ visibility: "off" }],
  },
  {
    featureType: "poi",
    elementType: "labels",
    stylers: [{ visibility: "off" }],
  },
];

const options = {
  gestureHandling: "greedy",
  streetViewControl: false, // This will remove the street view control button
  styles: mapStyles,
  // ... other options ...
};
function Component(props: any) {
  const queryArgs = new URLSearchParams(window.location.search);
  return (
    <>
      <Text>
        The final step to securing your identity is to select a secret location
        on the map below.
      </Text>
      <Text>
        The location you select is not sent to Center Identity, so make it as
        memorable and personal as possible.
      </Text>
      <Center mt="xl">
        <Text>Use this search box to get closer to the secret location.</Text>
      </Center>
      <Container size="xs">
        <Places setPlacesValue={props.setPlaces} />
      </Container>
      <Center mt="xs">
        <Text>
          Then zoom in further on this map and click or tap the exact location.
        </Text>
      </Center>
      <Center>
        <Map
          place={props.place}
          setSelectedLocation={props.setSelectedLocation}
          selectedLocation={props.selectedLocation}
          center={props.center}
          zoom={props.zoom}
          mapContainerStyle={{
            width: "100%",
            height: "350px",
          }}
          mapTypeId="hybrid"
          options={options}
          precision={4}
          overlay={true}
        />
      </Center>
      <Center mt="xs">
        <Button
          size="xs"
          variant="outline"
          radius="xl"
          onClick={() => {
            props.setSelectedLocation({ lat: "", lng: "" });
          }}
          disabled={
            props.selectedLocation.lat === "" || !props.selectedLocation.lat
          }
        >
          Reset location
        </Button>
      </Center>
      {queryArgs.get("stage") === "signin" && (
        <Center mt="xs">
          <Text
            color="blue"
            style={{ cursor: "pointer" }}
            onClick={async () => {
              await fetch("/email-hints?email=" + props.publicUsername);
              notifications.show({
                title: "Hints sent",
                message: "If you saved hints, we will email them to you now.",
                color: "green",
              });
            }}
          >
            Get secret location hint
          </Text>
        </Center>
      )}
      {queryArgs.get("stage") === "register" && (
        <>
          <Center>
            <Text mt="md" size="md" weight="bold">
              Hint for your secret location
            </Text>
          </Center>
          <Center>
            <Input
              value={props.selectedLocationHint}
              mt="xl"
              size="md"
              icon={<IconUser scale={50} />}
              placeholder="Hint for Secret Location"
              onChange={(e: any) =>
                props.setSelectedLocationHint(e.currentTarget.value)
              }
              onKeyDown={(e: any) => {
                if (e.key === "Enter") {
                  if (props.selectedLocationHint.length === 0) {
                    return;
                  }
                  props.paginate(1);
                }
              }}
              rightSection={
                <Tooltip
                  label='eg.
              "My favorite swing set", do not give away any location details.'
                  position="top-end"
                  withArrow
                >
                  <div>
                    <IconAlertCircle
                      size={18}
                      style={{ display: "block", opacity: 0.5 }}
                    />
                  </div>
                </Tooltip>
              }
            />
          </Center>
        </>
      )}
    </>
  );
}

export default Component;
